import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { alarmLogApi } from '@/api';
import { QUERY_KEY_CONST } from '@/constant';
import { useAuthStore } from '@/store';
import type { AlarmLogApi } from '@/type';

export const useAlarmLogListQuery = (
  param?: Partial<AlarmLogApi.GetList.Request>,
) => {
  const { user } = useAuthStore();
  const _param = {
    ...param,
    userID: user.id,
  };

  return useQuery({
    queryKey: QUERY_KEY_CONST.ALARM_LOG_KEYS.getList(_param),
    queryFn: () => alarmLogApi.getList(_param).then(res => res.data.resultData),
  });
};

export const useAlarmLogRemoveAllQuery = () => {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();

  return useMutation({
    mutationFn: () => {
      return alarmLogApi.removeAll();
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY_CONST.ALARM_LOG_KEYS.getList({ userID: user.id }),
      });
    },
  });
};
